import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import qs from 'querystring';
import { useApolloClient } from 'react-apollo';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Spin from 'components/common/Spin';
import {
  GET_EXERCISE,
  GET_STUDENT_EXERCISE_ID,
} from 'graphql/student/worksheets';
import Comments from 'components/exercise/Comments';
import useSnack from 'hooks/useSnack';
import Fab from '@material-ui/core/Fab';
import ForumIcon from '@material-ui/icons/Forum';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import ExerciseSteps from 'modules/student/worksheets/components/ExterciseSteps';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(248, 249, 252, .9)',
    backdropFilter: 'blur(8px)',
    paddingTop: 60,
    paddingBottom: 60,
    zIndex: 99,
  },
  content: {
    overflow: 'auto',
    height: 'calc(100vh - 80px)',
    paddingRight: 16,
  },
  header: {
    '& button': {
      position: 'absolute',
      top: 10,
      right: 20,
    },
  },
  fab: {
    position: 'fixed',
    right: 20,
    bottom: 20,
    zIndex: 100,
  },
}));

const AnswerView = ({
  location: { search },
  history,
  match: {
    params: { id, userId },
  },
}) => {
  const classes = useStyles();
  const query = qs.parse(search.substr(1));
  const client = useApolloClient();
  const [resp, setResp] = useState({});
  const user = useSelector((state) => state.user.user);
  const [showComments, setShowComments] = useState(false);
  const snack = useSnack();

  useEffect(() => {
    const { exercise } = query;
    if (exercise) {
      client
        .query({
          query: GET_STUDENT_EXERCISE_ID,
          variables: { exerciseId: exercise, userId },
        })
        .then(({ data }) => {
          if (data.data.length) {
            history.replace(
              `/students/${userId}/exercises/${data.data[0].id}/view`,
            );
          } else {
            snack.error('Student do not have access to this exercise.');
            history.push(`/students/${userId}/exercises`);
          }
        });
    } else {
      client
        .query({
          query: GET_EXERCISE,
          variables: {
            id,
          },
        })
        .then(setResp);
    }
  }, [id]);

  const { loading, error, data } = resp;

  if (loading || !data) return <Spin spinning linear />;

  if (error) return <div>{error.message}</div>;

  if (!data.data.length) return <div>Exercise Not found</div>;

  const { response, exercise } = data.data[0];

  const blocks = response || exercise.blocks;

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <IconButton onClick={() => history.goBack()}>
          <CloseIcon fontSize={'large'} />
        </IconButton>
      </div>
      <Container maxWidth="md">
        <Grid container alignItems="center">
          <Grid item xs={12} sm={12}>
            <div className={classes.content}>
              <Box marginBottom={2}>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  style={{ marginBottom: 24 }}
                >
                  {exercise.module.name} ~ {exercise.duration} minutes
                </Typography>
                <Typography color="textPrimary" variant="h6">
                  {exercise.name}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {exercise.description}
                </Typography>
              </Box>
              <ExerciseSteps
                blocks={blocks} />
            </div>
          </Grid>
        </Grid>
      </Container>
      <Fab
        color="primary"
        className={classes.fab}
        onClick={() => setShowComments(!showComments)}
      >
        {showComments ? <CloseIcon /> : <ForumIcon />}
      </Fab>
      <Slide
        timeout={150}
        direction="up"
        mountOnEnter
        unmountOnExit
        in={showComments}
      >
        <Comments userId={user.id} exerciseId={id} />
      </Slide>
    </div>
  );
};

export default AnswerView;
